import { useDispatch, useSelector } from "react-redux";
import classes from "./Education.module.css"
import { RootState } from "../../Store/store";
import { useEffect, useState } from "react";
import { ILesson } from "../../Intarfaces/ILesson";
import Button1 from "../../Components/UI/Button1/Button1";
import Button2 from "../../Components/UI/Button2/Button2";
import { lastStep } from "../../Store/userSlice";
import { useNavigate } from "react-router-dom";
import Progres from "../../Components/Progres/Progres";
import UserApi from "../../API/UserAPI";
import { IUserEdit } from "../../Intarfaces/IUser";
import FullSpaseLoader from "../../Components/UI/Loader/FullSpaseLoader";

const Education = () => {

    const dispatch = useDispatch()
    const lessons = useSelector((state:RootState)=>state.user.lessons)
    const user = useSelector((state:RootState)=>state.user.user)
    const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)
    const [lessonActive, setLessonActive]  = useState<ILesson>(lessons[maxActiveLessonId>lessons.length-1?lessons.length-1:maxActiveLessonId])
    const [isLessonMobileMenu,setIsLessonMobileMenu] = useState(false)
    const nav = useNavigate()


    const [isLoader, setIsLoader] = useState(false)
    const setLastStep = async () =>{
        setIsLoader(true)
        const response = await UserApi.edit({...user} as IUserEdit, maxActiveLessonId+1)
        setIsLoader(false)
        if(response.status!==200){
            console.log(response);
             return
        }
        
        dispatch(lastStep())
    }
    

    useEffect(() => {
        // Обработчик сообщений от плеера
        const handleMessage = (event:MessageEvent) => {
          // Проверяем источник сообщения
        //   if (event.origin !== 'https://rutube.ru') return;
          
          try {
            const message = JSON.parse(event.data);
            // console.log(`${message.type} || ${message.data.state}`);
            
            switch (message.type) {
              case 'player:changeState':
                if (message.data.state === 'completed') {
                  
                  
                  if(maxActiveLessonId===lessonActive.id){
                    setLastStep()
                  }
                }
                break; 
            }
          } catch (error) {}
        };
    
        // Подписываемся на события
        window.addEventListener('message', handleMessage);
    
        // Отписка при размонтировании
        return () => {
          window.removeEventListener('message', handleMessage);
        };
      }, [lessonActive,maxActiveLessonId]);

    return ( 
        <div className={classes.education}>
            <button className={classes.manuButton} onClick={()=> setIsLessonMobileMenu(!isLessonMobileMenu)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="24" viewBox="0 0 29 24" fill="none">
                <path d="M2 12H27" stroke="#00655B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 2H27" stroke="#00655B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 22H27" stroke="#00655B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </button>
            <div className={classes.container}>         
            <div className={isLessonMobileMenu?classes.smok:classes.smokNo} onClick={()=> setIsLessonMobileMenu(!isLessonMobileMenu)}/>  
             <div className={isLessonMobileMenu?classes.lessons:classes.lessonsMNon}>
                <Progres />
                { 
                    lessons?.map((item)=>{
                        return (
                            <button key={item.id} style={item.id===maxActiveLessonId && lessonActive.id!==item.id?{color:'#00655b'}:{}} disabled={item.id>maxActiveLessonId}  onClick={()=>{setIsLessonMobileMenu(false);setLessonActive(lessons[item.id])}} 
                            
                            className={
                                lessonActive.id===item.id
                            ?
                            classes.lessonItemActive
                            :
                            item.id<=maxActiveLessonId?
                            classes.lessonItem
                            :
                            classes.lessonItemDisabled
                            }>

                                {item.title}
                            </button>
                        )
                    })
                }
                <div style={{minHeight:"50px" }}></div>
                
             </div>
             <div className={classes.lessonContainer}>
                <div className={classes.title}>
                    {lessonActive.title}
                </div>
                {
                    lessonActive.title==="Итоговое тестирование" && maxActiveLessonId>=lessons.length?
                    <>
                        <div className={classes.lessonContainer2}>
                        <div className={classes.titleTrue}>
                           <p>Тестирование успешно пройдено!</p> 
                            <p>Скачать сертификат можно в личном кабинете</p>
                        </div>
                        
                            <Button1 onClick={()=>nav('/accaunt')}>Перейти в личный кабинет</Button1>
                                           
                    </div>
                    </>
                    :
                    lessonActive.title==="Итоговое тестирование"?
                    <>
                        <div className={classes.text}>
                            <p>Перед Вами итоговый Тест проверки знаний Школы поддержки инклюзии #ЗАОДНО ДОБРО. Оцените свои знания материала наших лекций.</p>

                            <p>Всем нашим слушателям мы даем неограниченное число попыток прохождения теста!</p>

                            <p>{"После успешного прохождения Вам будет доступен сертификат для скачивания.\nСертификат - это документальное подтверждение окончания Школы поддержки инклюзии #ЗАОДНО ДОБРО"}</p>
                        </div>
                        <div className={classes.buttons}>
                            <Button2 disabled={lessonActive.id===0} onClick={()=>setLessonActive(lessons[lessonActive.id-1])}>Вернуться назад</Button2>

                            <Button1 
                            
                            onClick={()=>nav('/test')}
                            >
                            Перейти к тестированию
                            </Button1>

                        </div>
                    </>
                    :
                    <>
                    <div className={classes.tema}>
                    <span>Тема:</span> {lessonActive.tema}
                    </div>
                    <div className={classes.tema}>
                    <span>Лектор:</span> {lessonActive.lector}
                    </div>
                <div className={classes.videos}>
                {
                    lessonActive?.videos?.map((item, index)=>{
                        return (
                            <div key={index} className={classes.video}>
                                
                            <iframe
                            style={{border:"none", borderRadius:"5px"}}
                            width="516"
                            height="290"
                            src={`https://rutube.ru/play/embed/${item}&autoplay=0`}
                            allow="clipboard-write; autoplay"
                            allowFullScreen
                            
                            ></iframe>    
                            
                            </div>
                        )
                    })
                }
                </div>
                <div className={classes.videosM}>
                {
                    lessonActive?.videos?.map((item, index)=>{
                        return (
                            <div key={index} className={classes.video}>
                                
                            <iframe
                            style={{border:"none", borderRadius:"5px"}}
                            width="270"
                            height="152"
                            src={`https://rutube.ru/play/embed/${item}&autoplay=0`}
                            allow="clipboard-write; autoplay"
                            allowFullScreen
                            
                            ></iframe>    
                            
                            </div>
                        )
                    })
                }
                </div>
                <div className={classes.buttons}>
                    <Button2 disabled={lessonActive.id===0} onClick={()=>setLessonActive(lessons[lessonActive.id-1])}>Вернуться назад</Button2>

                    <Button1 
                    disabled={lessonActive.id>=maxActiveLessonId} 
                    onClick={()=>setLessonActive(lessons[lessonActive.id+1 ])}
                    title={lessonActive.id>=maxActiveLessonId?'Для перехода на следующие заниятие нужно закончить просмотр текущего':''}
                    >
                        <FullSpaseLoader isLoader={isLoader}/>
                    Следующий шаг
                    </Button1>

                </div>
                    </>
                    
                    
                }
                
             </div>
             </div>
        </div>
     );
}
 
export default Education;